<script setup>
import { ref, onMounted } from "vue";

import UserDetail from "./components/UserDetail.vue";
import axios from "axios";
import { BACK_END_URL } from "@/utilities/config";

const cedula = ref("");
const suggestions = ref([]);
const showDropdown = ref(false);
const isLoading = ref(false); // Estado de carga

const selectedUser = ref(null);
const showModal = ref(false);

const props = defineProps({
  provinceId: String, // El ID de la provincia recibido del padre
  applyFilters: {
    type: Boolean,
    default: false,
  },
  isColaborador: {
    type: Boolean,
  },
});

const fetchSuggestions = async () => {
  if (cedula.value.length < 5) {
    suggestions.value = [];
    showDropdown.value = false;
    return;
  }

  try {
    const token = sessionStorage.getItem("token");

    // Determinar el endpoint basado en isColaborador
    const endpoint = props.isColaborador
      ? `${BACK_END_URL}/analytics/junta/search-by-id`
      : `${BACK_END_URL}/analytics/search-by-id`;

    const response = await axios.get(`${endpoint}/${cedula.value}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    suggestions.value = response.data ? [response.data] : [];
    showDropdown.value = suggestions.value.length > 0;
  } catch (error) {
    console.error("Error fetching suggestions:", error);
    suggestions.value = [];
    showDropdown.value = false;
  }
};

const openModal = (userOrCedula) => {
  // Si se proporciona un objeto de usuario completo (clic en el dropdown)
  selectedUser.value = userOrCedula;
  showModal.value = true;
};
</script>

<template>
  <div class="p-3 py-md-4 p-lg-4 container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <div class="card full-height">
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between">
              <h6 class="mb-0">Ver Elector</h6>
            </div>
          </div>

          <div class="p-3 card-body">
            <div
              class="row pe-3 justify-content-center align-items-center mt-2"
            >
              <p class="text-lg">
                Ingrese el número de cédula del Elector que desea buscar:
              </p>

              <div
                class="col-lg-12 mt-5 mb-4 d-flex align-items-center justify-content-center"
              >
                <i class="fas fa-id-card fa-6x"></i>
              </div>

              <!-- Columna Izquierda: Provincia, Cantón, Distrito -->
              <div
                v-if="!isLoading"
                class="col-lg-6 col-12 d-flex align-items-center justify-content-end"
              >
                <div class="form-check form-check-inline w-100 ps-0">
                  <input
                    v-model="cedula"
                    class="form-control w-100"
                    :class="{ 'is-invalid': errorMessage2 }"
                    style="
                      font-size: 1.5rem;
                      padding: 0.75rem 1rem;
                      height: 3.5rem;
                      border-width: 2px;
                      border-color: #e9ecef;
                      transition: all 0.3s ease;
                      letter-spacing: 0.03em;
                    "
                    :style="
                      errorMessage2
                        ? 'border-bottom: 4px solid #f5365c !important;'
                        : 'border-bottom: 4px solid #54d79f !important'
                    "
                    placeholder="Número de Cédula (ejemplo: 101230507)"
                    type="tel"
                    @input="fetchSuggestions"
                  />
                  <ul v-if="showDropdown" class="dropdown-menu show">
                    <li
                      v-for="user in suggestions"
                      :key="user.cedula"
                      @click="openModal(user)"
                      class="suggestion-item"
                    >
                    <a v-if="user.cedula" class="dropdown-item py-3">
                        <!-- First Row - Cédula -->
                        <div class="d-flex align-items-center mb-2">
                            <i class="fas fa-id-card me-3"></i>
                            <span class="cedula-text">{{ user.cedula }}</span>
                        </div>
                        
                        <!-- Second Row - Name -->
                        <div class="d-flex align-items-center">
                            <i class="fas fa-user me-4"></i>
                            <span class="name-text">
                            {{ user.nombre }} 
                            {{ user.primer_apellido }}
                            {{ user.segundo_apellido }}
                            </span>
                        </div>
                    </a>

                      <a v-else class="dropdown-item text-lg py-3">
                        No hay coincidencias
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-center mt-5" v-if="isLoading">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Cargando...</span>
            </div>
          </div>

          <UserDetail
            v-if="showModal"
            :user="selectedUser"
            @close="showModal = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.dropdown-menu {
  z-index: 998 !important;
  width: 50% !important;
  height: auto;
}

.no-data-message {
  text-align: center;
  font-size: 16px;
  color: #888;
  padding: 20px;

  /* Centering the message */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  /* Ensure the message takes up the full height of the container */
}

.full-height {
  height: 800px;
}

.suggestion-item {
  letter-spacing: 0.03em; /* Base spacing for entire item */
}

.cedula-text {
    letter-spacing: 0.03em;
    font-weight: 500;
  min-width: 120px; /* Fixed width for alignment */
}

.name-text {
   letter-spacing: 0.03em;
}

.dropdown-item {
  font-size: 1.2rem;
  transition: all 0.2s ease;
  width: 600px;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}
</style>
